import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import StickyCTA from "@/components/site/StickyCTA";
import InstallPrompt from "@/components/site/InstallPrompt";
import SmoothScroll from "@/components/site/SmoothScroll";
import { captureUTMFromURL } from "@/lib/utm";

export default function SiteLayout() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    captureUTMFromURL();
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, search]);

  return (
    <div className="min-h-screen flex flex-col bg-brand-cream">
      <SmoothScroll />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <StickyCTA />
      <InstallPrompt />
    </div>
  );
}
